const If = (props) => {
  if (props.condition && props.children) {
    return props.children;
  }
  return props.default || null;
};
export default If;
